<template>
  <!-- 中间图片的横幅头部 -->
  <div class="heng_box">
    <div class="heng">
      <div class="heng_text">
        <slot name="title"></slot>
      </div>
    </div>
    <!-- 中间图片的横幅表格 -->
    <div class="heng_table">
      <img
        src="https://fview.5kjs.com/activity/21sign/image/pc/indexImage/center_show.png"
        alt=""
        class="table_show"
        draggable="false"
      />
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "CenterTable",
};
</script>

<style lang="less" scoped>
.heng_box {
  width: 84.3125rem;
  margin: auto;
  height: auto;

  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  // 中间图片的横幅头部
  .heng {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    position: relative;
    top: -4.25rem;
    width: 84.3125rem;
    height: 13.25rem;
    background: url(https://fview.5kjs.com/activity/21sign/image/pc/indexImage/center_hengfu.png)
      no-repeat;
    background-size: 100% 100%;
    .heng_text {
      padding: 3.3125rem 0 6.375rem 0;
      font-size: 3.75rem;
      font-family: "Source Han Sans CN";
      font-weight: bold;
      color: #ffffff;
      line-height: 2.5625rem;
      text-align: center;
    }
  }
  //   中间图片的横幅表格
  .heng_table {
    position: relative;
    top: -7.6rem;
    z-index: 2;
    margin: auto;
    // margin-top: -2.25rem;
    width: 75.875rem;
    // height: 43.9375rem;
    background: #ffffff;
    box-shadow: 0rem 0.3125rem 1.625rem 0rem rgba(255, 77, 42, 0.26);
    border-radius: 0rem 0rem 1.75rem 1.75rem;
    .table_show {
      z-index: -1;
      width: 100%;
      height: 3.75rem;
      position: relative;
      top: 0;
      left: 0;

      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }
  }
}
</style>